import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { INavbarLink } from '../../../types/navbar';
import { ERubric } from '../../../types/rubricsLinks';
import { trackNavBarClick } from '../tracking';

interface INavBarProps {
  regionId: number;
  excludeSuburbanRegionsIds: number[];
  isAuthenticated: boolean;
  rubricsLinks: INavbarLink[];
  specialPromo: React.ReactNode;
  navbarRef: React.RefObject<HTMLDivElement | null>;
  onItemMouseOver(rubric: ERubric): void;
  onItemMouseOut(): void;
}

export const NavBar: React.FC<INavBarProps> = ({
  regionId,
  excludeSuburbanRegionsIds,
  rubricsLinks,
  specialPromo,
  isAuthenticated,
  navbarRef,
  onItemMouseOut,
  onItemMouseOver,
}) => {
  const isWideSpecialPromo = excludeSuburbanRegionsIds.includes(regionId) && specialPromo;

  return (
    <nav
      className={clsx(
        styles['navigation'],
        isAuthenticated && styles['is-authenticated'],
        isWideSpecialPromo && styles['is-wide-special-promo'],
        specialPromo && styles['has-special-promo'],
      )}
      data-testid="navbar-redesign"
      ref={navbarRef}
    >
      <ul className={styles['list']}>
        {rubricsLinks.map(({ rubric, active, hovered, title, component, url }) => {
          if (component) {
            return (
              <li key={rubric} className={styles['list-item']} onMouseOver={() => onItemMouseOver(rubric)}>
                {component}
              </li>
            );
          }

          return (
            <li
              key={rubric}
              data-testid="nav-item"
              className={clsx(
                styles['list-item'],
                active && styles['active'],
                hovered && styles['hovered'],
                // для регионов с длинными названиями спецпроектов мы не показываем раздел Дома и участки
                // (из-за того, что в хэдере нет места)
                excludeSuburbanRegionsIds.includes(regionId) && rubric === ERubric.Countryside && styles['invisible'],
              )}
              onMouseOver={() => onItemMouseOver(rubric)}
              onMouseOut={onItemMouseOut}
            >
              {url && (
                <a className={styles['link']} href={url} onClick={() => trackNavBarClick(rubric, url)}>
                  {title}
                </a>
              )}
              {!url && (
                <span data-testid="title" className={styles['link']} onClick={() => trackNavBarClick(rubric)}>
                  {title}
                </span>
              )}
            </li>
          );
        })}
      </ul>
      {specialPromo && <div className={styles['special-promos']}>{specialPromo}</div>}
    </nav>
  );
};
